/* Extracted from snippets/product-grid.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(() => {
              const grid = document.querySelector('.product-grid');
              if (!grid) return;

              const storedLayoutMobile = sessionStorage.getItem('product-grid-view-mobile') || 'default';
              const storedLayoutDesktop = sessionStorage.getItem('product-grid-view-desktop') || 'default';

              // No need to read the window width if no custom layouts were saved.
              if (storedLayoutMobile === 'default' && storedLayoutDesktop === 'default') return;

              const storedLayout = window.innerWidth >= 750 ? storedLayoutDesktop : storedLayoutMobile;
              if (storedLayout === 'default') return;

              grid.setAttribute('product-grid-view', storedLayout);

              const options = document.querySelectorAll(
                'input[type="radio"][name="grid"], input[type="radio"][name="grid-mobile"]'
              );
              for (const option of options) {
                option.checked = option.value === storedLayout;
              }
            })();
